import { RouteRecordRaw } from 'vue-router'
import { isAuthenticated, userRole } from '@/lib/AuthenticatorPlugin.ts'
import redirectToUserRoot from '@/composables/redirectToUserRoot.ts'

const HomepageContainer = () => import('@/views/Otivo/HomepageContainer.vue')

const OtivoSuperReport = () => import('@/views/Otivo/Brand/Solutions/OtivoSuperReport.vue')
const AboutUs = () => import('@/views/Otivo/Brand/About/AboutUs.vue')
const ContactUs = () => import('@/views/Otivo/Brand/About/ContactUs.vue')
const HowOtivoMakesMoney = () => import('@/views/Otivo/Brand/About/HowOtivoMakesMoney.vue')
const FAQs = () => import('@/views/Otivo/Brand/Resources/FAQs.vue')
const RedirectToCompany = () => import('@/components/RedirectToCompany/RedirectToCompany.vue')

const CFSRetirementCalculator = () => import('@/views/Clients/CFS/CFSRetirementCalculator.vue')

const SampleDashboard = () => import('@/views/Otivo/Brand/SampleDashboard.vue')
const SampleAssets = () => import('@/views/Otivo/Brand/SampleAssets.vue')
const SampleColours = () => import('@/views/Otivo/Brand/SampleColours.vue')
const SampleComponents = () => import('@/views/Otivo/Brand/SampleComponents.vue')
const SampleTypography = () => import('@/views/Otivo/Brand/SampleTypography.vue')

export default [
  {
    path: '/',
    name: 'home',
    component: HomepageContainer,
    beforeEnter: (to, from, next) => {
      redirectToUserRoot(userRole.value, isAuthenticated.value, next)
    },
  },
  {
    path: '/employee-wellbeing',
    name: 'employee-wellbeing',
    meta: {
      type: 'business',
    },
    component: () => import('@/views/Otivo/Brand/Services/EmployeeWellbeing.vue'),
  },
  {
    path: '/download-wellbeing-report-form',
    alias: '/download-wellbeing-report',
    name: 'wellbeing-report-form',
    meta: {
      type: 'business',
    },
    component: () => import('@/views/Otivo/Brand/Services/DownloadWellbeingReportForm.vue'),
  },
  {
    path: '/super-report',
    name: 'super-report',
    meta: {
      type: 'business',
    },
    component: OtivoSuperReport,
  },
  // END BUSINESS
  // START ABOUT
  // {
  //   path: '/advice-overview',
  //   name: 'Advice overview',
  //   component: AdviceOverview,
  // },
  {
    path: '/our-team',
    name: 'about-otivo',
    component: AboutUs,
  },
  {
    path: '/contact-us',
    name: 'contact-us',
    component: ContactUs,
  },
  {
    path: '/how-otivo-makes-money',
    name: 'how-otivo-makes-money',
    component: HowOtivoMakesMoney,
  },
  // END ABOUT
  // RESOURCES
  {
    path: '/financial-fitness',
    name: 'financial-fitness',
    component: () => import('@/app/views/Resources/FinancialFitnessTest.vue'),
  },
  {
    path: '/faq',
    name: 'faq',
    component: FAQs,
  },
  {
    path: '/learn',
    name: 'Learning hub',
    component: () => import('@/views/Otivo/Brand/Resources/Articles/Articles.vue'),
  },
  {
    path: '/learn/search',
    name: 'Search',
    component: () => import('@/views/Otivo/Brand/Resources/Articles/Search.vue'),
  },
  {
    path: '/learn/security',
    name: 'Article Security',
    component: () => import('@/views/Otivo/Brand/Resources/Articles/Security.vue'),
  },
  {
    path: '/learn/:slug+',
    name: 'Slug',
    component: () => import('@/views/Otivo/Brand/Resources/Articles/Article.vue'),
  },
  {
    path: '/ask-otivo-super',
    name: 'Ask Otivo super',
    component: () => import('@/views/Otivo/Brand/Resources/AskOtivoSuper.vue'),
  },
  {
    path: '/home',
    redirect: '/',
  },
  {
    path: '/company/:company',
    name: 'redirect-to-company',
    component: RedirectToCompany,
  },
  {
    path: '/sample',
    component: SampleDashboard,
    beforeEnter: (to, from, next) => {
      if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging') next()
    },
    children: [
      {
        path: 'assets',
        name: 'sampleAssets',
        component: SampleAssets,
      },
      {
        path: 'colours',
        name: 'sampleColours',
        component: SampleColours,
      },
      {
        path: 'components',
        name: 'sampleComponents',
        component: SampleComponents,
      },
      {
        path: 'typography',
        name: 'sampleTypography',
        component: SampleTypography,
      },
    ],
  },
  // This should be on CFS routes, but until they change their URL it'll be here for the time being
  {
    path: '/cfs/retirementCalculator',
    name: 'cfsRetirementCalculator',
    component: CFSRetirementCalculator,
    beforeEnter: () => {
      const trackingScript = document.createElement('script')
      trackingScript.src = import.meta.env.VITE_CFS_TRACKING_URL
      trackingScript.type = 'text/javascript'
      trackingScript.async = true
      document.getElementsByTagName('head')[0].appendChild(trackingScript)
    },
  },
  // SEO-friendly redirects for empty/legacy pages
  {
    path: '/about',
    redirect: '/our-team',
  },
  {
    path: '/about/our-story',
    redirect: '/our-team',
  },
  {
    path: '/about/people.html',
    redirect: '/our-team',
  },
  {
    path: '/advice-overview',
    redirect: '/advice-practices',
  },
  {
    path: '/advisers',
    redirect: '/advice-practices',
  },
  {
    path: '/AFA/',
    redirect: '/advice-practices',
  },
  {
    path: '/business',
    redirect: '/advice-practices',
  },
  {
    path: '/compareme',
    redirect: '/',
  },
  {
    path: '/contact',
    redirect: '/contact-us',
  },
  {
    path: '/contact/people.html',
    redirect: '/contact-us',
  },
  {
    path: '/contactUs',
    redirect: '/contact-us',
  },
  {
    path: '/corporate-wellbeing',
    redirect: '/employee-wellbeing',
  },
  {
    path: '/goal/2',
    redirect: '/',
  },
  {
    path: '/how_it_works',
    redirect: '/faq',
  },
  {
    path: '/index.html',
    redirect: '/',
  },
  {
    path: '/onboard_user/onboarded_user',
    redirect: '/',
  },
  {
    path: '/otivo-super-report',
    redirect: '/super-report',
  },
  {
    path: '/overview.html',
    redirect: '/',
  },
  {
    path: '/people.html',
    redirect: '/our-team',
  },
  {
    path: '/personal',
    redirect: '/select-plan',
  },
  {
    path: '/pricing',
    redirect: '/select-plan',
  },
  {
    path: '/projects/seyboldsf/7.html',
    redirect: '/',
  },
  {
    path: '/resources',
    redirect: '/learn',
  },
  {
    path: '/scenario_super',
    redirect: '/',
  },
  {
    path: '/services',
    redirect: '/',
  },
  {
    path: '/staff/leanne/grandma/',
    redirect: '/',
  },
] as Array<RouteRecordRaw>
